// constants/clients.js
// Mapeo de sitios → name → clientId → mpPublicKey (Mercado Pago)

export const CLIENTS = [
  {
    name: "maranindumentaria",
    url: "https://maranindumentaria.jaypionba.com/",
    clientId: 1,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_MARAN",
  },
  {
    name: "horaliconfecciones",
    url: "https://horaliconfecciones.com/",
    clientId: 4,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_HORALI",
  },
  {
    name: "cocowalk",
    url: "https://cocowalk.com.ar/",
    clientId: 5,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_COCOWALK",
  },
  {
    name: "pimpampumbabys",
    url: "https://pimpampumbabys.com/",
    clientId: 6,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_PIMPAMPUM",
  },
  {
    name: "centralonlineshop",
    url: "https://centralonlineshop.jaypionba.com/",
    clientId: 16,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_CENTRAL",
  },
  {
    name: "fusion",
    url: "https://fusion.jaypionba.com/",
    clientId: 16,
    mpPublicKey: "TEST-49ffa44f-4770-4125-af1c-0135c51d4603",
  },
  {
    name: "inspiraciondenim",
    url: "https://inspiraciondenim.jaypionba.com/",
    clientId: 16,
    mpPublicKey: "TEST-49ffa44f-4770-4125-af1c-0135c51d4603",
  },
  {
    name: "textilmarketoficial",
    url: "https://textilmarketoficial.com/",
    clientId: 14,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_TEXTILMARKET",
  },
  {
    name: "laraindumentaria",
    url: "https://laraindumentaria.jaypionba.com/",
    clientId: 17,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_LARA",
  },
  {
    name: "nuvisionoptica",
    url: "https://nuvisionoptica.com/",
    clientId: 7,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "man",
    url: "https://man.jaypionba.com/",
    clientId: 18,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "yafot",
    url: "https://yafot.com.ar/",
    clientId: 19,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "mercy-ind",
    url: "https://mercy-ind.com/",
    clientId: 20,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "sandyproietti",
    url: "https://sandyproietti.com/",
    clientId: 21,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "Eilatec",
    url: "https://eilatec.jaypionba.com/",
    clientId: 26,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "zonadigital",
    url: "https://zonadigital.jaypionba.com/",
    clientId: 27,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "lenceriacoria",
    url: "https://lenceriacoria.jaypionba.com/",
    clientId: 31,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "Maracuxa",
    url: "https://Maracuxa.jaypionba.com/",
    clientId: 35,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
  {
    name: "jadpaamit",
    url: "https://jadpaamit.jaypionba.com/",
    clientId: 36,
    mpPublicKey: "REEMPLAZAR_MP_PUBLIC_KEY_NUVISION",
  },
];

// ===================== Helpers de normalización =====================
const toLower = (s = "") => s.toLowerCase();
const stripTrailingSlash = (u = "") => u.replace(/\/+$/, "");

// Quita port y "www." del host
const normalizeHost = (host = "") => {
  const noPort = host.split(":")[0];
  return toLower(noPort).replace(/^www\./, "");
};

const hostFromUrl = (urlStr = "") => {
  try {
    return normalizeHost(new URL(urlStr).host);
  } catch {
    return "";
  }
};

// TLDs compuestos comunes en AR (podés agregar más si necesitás)
const MULTI_TLDS = ["com.ar", "net.ar", "org.ar", "gov.ar", "edu.ar"];

/**
 * Extrae un "site key" genérico desde un host:
 * - Si hay subdominio (no www), devuelve el primer label (izquierda).
 *   ej: fusion.jaypionba.com -> "fusion"
 * - Si NO hay subdominio (apex), devuelve el SLD respetando TLDs compuestos:
 *   ej: cocowalk.com.ar -> "cocowalk"
 *       pimpampumbabys.com -> "pimpampumbabys"
 */
export function getSiteKeyFromHost(host = "") {
  const h = normalizeHost(host);
  if (!h) return null;

  const parts = h.split(".");
  if (parts.length === 1) return parts[0]; // localhost o similar

  // ¿tiene subdominio real (distinto de www, ya removido)?
  // Para dominios con TLD simple (.com): baseCount = 2 (sld + tld)
  // Para TLD compuesto (.com.ar): baseCount = 3 (sld + com + ar)
  const tld2 = parts.slice(-2).join(".");
  const tld3 = parts.slice(-3).join(".");

  const endsWithMulti = MULTI_TLDS.some((t) => h.endsWith(t));
  const baseCount = endsWithMulti ? 3 : 2;

  if (parts.length > baseCount) {
    // Hay subdominio → primer label
    return parts[0];
  }
  // Apex → SLD (el label antes del TLD o TLD compuesto)
  return parts[parts.length - baseCount];
}

/** Versión por origin completo (más útil en browser) */
export function getSiteKey(origin = (typeof window !== "undefined" ? window.location.origin : "")) {
  try {
    const host = new URL(origin).host;
    return getSiteKeyFromHost(host);
  } catch {
    return null;
  }
}

/**
 * Busca la config de CLIENTS por:
 * 1) name (match exacto con el site key)
 * 2) host (match exacto ignorando www/puerto)
 * 3) prefix del origin normalizado (fallback)
 */
export function getClientConfig(origin = (typeof window !== "undefined" ? window.location.origin : "")) {
  const siteKey = getSiteKey(origin);
  if (siteKey) {
    const byName = CLIENTS.find((c) => c.name === siteKey);
    if (byName) return byName;
  }

  // Match por host normalizado
  let currentHost = "";
  try {
    currentHost = normalizeHost(new URL(origin).host);
  } catch {
    currentHost = "";
  }
  if (currentHost) {
    const byHost = CLIENTS.find((c) => hostFromUrl(c.url) === currentHost);
    if (byHost) return byHost;
  }

  // Fallback por prefix del origin
  const normOriginNoSlash = stripTrailingSlash(toLower(origin)).replace("://www.", "://");
  return (
    CLIENTS.find((c) => {
      const cNorm = stripTrailingSlash(toLower(c.url)).replace("://www.", "://");
      return normOriginNoSlash.startsWith(cNorm);
    }) || null
  );
}

export default CLIENTS;
